import { jsx } from "react/jsx-runtime";
import { DatePickerFieldWUT } from "../../../ui/date-picker-field/date-picker-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DextDatePickerWUT = (props) => {
  const fieldType = FIELD_TYPES.DEXT_DATE_PICKER;
  return /* @__PURE__ */ jsx(DatePickerFieldWUT, { ...props, fieldType });
};
export {
  DextDatePickerWUT
};
//# sourceMappingURL=dext-date-picker-wut.js.map
